module.exports = __webpack_public_path__ + "static/media/BIMpic9.95f94d8e.png";